"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostPeer = void 0;
const peer_1 = require("./peer");
const types_1 = require("./types");
class HostPeer extends peer_1.BasePeer {
    signal(signal) {
        {
            if (this.peer.connected) {
                return;
            }
            this.handleInitiatorPath(signal);
        }
    }
    handleInitiatorPath(signal) {
        var _a, _b;
        if (signal.source !== "CLIENT")
            return;
        const { sdp } = signal;
        const peer = this._peers[this._peers.length - 1];
        if (peer.connected)
            return;
        if (signal.event === "CANDIDATE" && signal.sdp === "noop") {
            !this.noopReceived && this._cb();
            this.noopReceived = true;
            setTimeout(() => this.noopReceived = false, 5000);
            return;
        }
        if (signal.event === "CANDIDATE" && peer.trickle) {
            const candidate = {
                candidate: signal.sdp,
                sdpMLineIndex: 0,
                sdpMid: "0"
            };
            const ICECandidate = typeof (RTCIceCandidate) !== "undefined" ? new RTCIceCandidate(candidate) : (_a = this._wrtc) === null || _a === void 0 ? void 0 : _a.RTCIceCandidate(candidate);
            peer === null || peer === void 0 ? void 0 : peer.signal({ type: "candidate", candidate: ICECandidate });
        }
        if (signal.event === "ANSWER") {
            const { event } = signal;
            const type = event.toLowerCase();
            const answer = {
                type,
                sdp
            };
            if (peer) {
                if (sdp.indexOf("trickle") === -1) {
                    peer.trickle = false;
                    this._trickle = false;
                }
                try {
                    void ((_b = peer === null || peer === void 0 ? void 0 : peer.ready) === null || _b === void 0 ? void 0 : _b.then(() => {
                        peer.signal(answer);
                    }));
                }
                catch (error) {
                    this.debugger.warn({
                        title: types_1.LogTypes.signalAnswer,
                        args: { error }
                    });
                }
            }
        }
    }
}
exports.HostPeer = HostPeer;
//# sourceMappingURL=hostpeer.js.map